import {
  NoteContentField,
  NoteContextField,
  SendNoteByMailField,
} from '@src/notes/NoteFields';
import * as yup from 'yup';

export const AddNoteSchema = yup.object().shape({
  [NoteContextField.fieldName]: NoteContextField.validator,
  [NoteContentField.fieldName]: NoteContentField.validator,
  [SendNoteByMailField.fieldName]: SendNoteByMailField.validator,
});

export type AddNoteSchemaType = yup.InferType<typeof AddNoteSchema>;
